import { Box, Button, Grid2 as Grid, Typography } from '@mui/material';

import React from 'react';
import { UserCounters, UserDetail } from '../types';
import hall_of_fame from '../assets/hall_of_fame.png';
import masterpiece from '../assets/masterpiece.png';
import milestones from '../assets/milestone.png';
import treasure from '../assets/treasure.png';
import { useNavigate } from 'react-router-dom';

interface UserBadgesProps {
  userCounters: UserCounters | null;
  counterError: string | null;
  isMobile: boolean | null;
  gradientTextStyles: Function;
  userId: string | undefined;
  userDetail: UserDetail | null;
  handle: string | undefined;
}

const UserBadges: React.FC<UserBadgesProps> = ({
  userCounters,
  counterError,
  isMobile,
  gradientTextStyles,
  userId,
  userDetail,
  handle
}) => {
  const navigate = useNavigate();
  const handleActions = (label: string) => {
    navigate(`/user/${handle}/${label.toLowerCase()}`, {
      state: { userDetail, userId, handle }
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography
        variant={isMobile ? 'h6' : 'h4'}
        sx={{ fontFamily: 'Baloo2', fontSize: '32px', fontWeight: '800', letterSpacing: '8px' }}>
        BADGES
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, sm: 4, md: 4 }}
        my={5}
        sx={{ justifyContent: 'center', placeItems: 'center', alignItems: 'flex-start' }}
        padding={{ sm: '0px', md: '5px 10px' }}>
        {counterError ? (
          <Typography color="error">{counterError}</Typography>
        ) : (
          <>
            {[
              {
                label: 'Masterpiece',
                value: userCounters?.masterpiece,
                icon: masterpiece
              },
              {
                label: 'Treassure',
                value: userCounters?.wonders,
                icon: treasure
              },
              {
                label: 'Hall Of Fame',
                value: userCounters?.hall_of_fame,
                icon: hall_of_fame
              },
              {
                label: 'Clubs',
                value: userCounters?.clubs,
                icon: milestones
              }
            ].map(({ label, value, icon }, idx) => (
              <Grid
                onClick={label === 'Clubs' ? () => handleActions(label) : undefined}
                key={idx}
                size={{ xs: 3, sm: 3, md: 3 }}
                sx={{
                  alignItems: 'center',
                  textAlign: 'center',
                  objectFit: 'contain',
                  placeItems: 'center',
                  cursor: label === 'Clubs' ? 'pointer' : 'none'
                }}>
                <img src={icon} alt={label} width={isMobile ? '75%' : 'auto'} height={isMobile ? '75%' : 'auto'} />

                <Typography
                  fontSize={{ xs: '13px', sm: '9px', md: '13.52px' }}
                  sx={{ textAlign: 'center' }}
                  fontFamily="Baloo2"
                  fontWeight={800}
                  whiteSpace="nowrap"
                  alignSelf="center"
                  lineHeight={{ xs: '16px', md: '23.04px' }}
                  margin={{ sm: '0px', md: '3px' }}
                  padding={{ sm: '0px', md: '3px' }}>
                  {label}
                </Typography>
                <Typography
                  fontSize={{ xs: '13px', sm: '9px', md: '13.52px' }}
                  sx={{ textAlign: 'center' }}
                  fontFamily="Baloo2"
                  fontWeight={500}
                  lineHeight={{ xs: '16px', md: '23.04px' }}>
                  {value}
                </Typography>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default UserBadges;
